export class AdminUserReportsController {
  constructor($scope, UserService, $http, $timeout) {
    $scope.vm = this;
    this.http = $http;
    this.timeout = $timeout;
    this.UserService = UserService;
    this.scope = $scope;
    this.scope.reports = {};
    this.scope.allReportsSelected = {state: false};
    this.scope.reportsSelected = {};
    this.triggerCountdown = 0;

    this.scope.pagination = {
      total: 0,
      currentPage: 1,
      limit: 12
    };

    this.init();
  }

  init() {
    this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);

      this.limitTimout = this.timeout(() => {
        this.scope.getUsersReports(1);
      }, 200);
    }

    this.scope.getUsersReports =(page) =>{

      // filter empty by default
      var filtr = {},
          limit = this.scope.pagination.limit;

      this.UserService.getUserReports(filtr, page, limit)
        .then((_res) => { let response = _res.data;
          if(response.success){
            this.scope.reports = response.data;
            this.scope.pagination.total = response.itemCount;

            // Remove old users' keys when being navigated to new page
            this.scope.reportsSelected = {};

            _.forEach(this.scope.reports, (report) => {
              this.scope.reportsSelected[report._id] = false;
            });

            this.scope.allReportsSelected.state = false;
          }
        })
        .catch((response) => { let error = response.data;
          console.log('Cannot get new users:   ', error);
        });

    };


    /**
     * Check every checkbox on the page
     */
    this.scope.selectAllReports = () => {

      var check = this.scope.allReportsSelected.state;

      _.forEach(this.scope.reportsSelected, (val, key) => {
        this.scope.reportsSelected[key] = !!check;
      })
    };

    this.scope.deleteSelectedReports = () => {

      _.forEach(this.scope.reportsSelected, (val, key) => {
        if (val === true) {
          this.triggerCountdown++;
        }
      });

      if (this.triggerCountdown < 1 || !confirm('Are you sure to want to do this?'))
        return;

      // Remove all checked reports
      _.forEach(this.scope.reportsSelected, (val, key) => {
        if (val === true) {
          //this.triggerCountdown++;

          this.UserService.deleteUserReports(key)
            .then((response) => { let message = response.data;
              this.triggerCountdown--;
              if (this.triggerCountdown === 0) {
                this.refreshPage();
              }
            })
            .catch((response) => { let error = response.data;
              console.log(error);
              this.triggerCountdown--;
              if (this.triggerCountdown === 0) {
                this.refreshPage();
              }
            });
        }
      });

    };

    this.scope.getUsersReports(this.scope.pagination.currentPage);

  }

  refreshPage() {
    // Calculates amount of users have been approved (were removed from total)
    var itemsRemoved = _.size(this.scope.reportsSelected);
    _.forEach(this.scope.reportsSelected, (val, key) => {
      if (val === false) { itemsRemoved--; }
    } );

    // Stay on the current page unless the removals put it past the end of the
    // shortened list.
    var lastPage = Math.max(1, Math.ceil((this.scope.pagination.total - itemsRemoved) / this.scope.pagination.limit));
    var page = Math.min(this.scope.pagination.currentPage, lastPage);

    this.scope.getUsersReports(page);

  }
}
